import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { pagetrafficwithconversion: { getPageTrafficWithConversion,getPageTrafficWithConversionForGraph } } = apiUrls;

export const PAGE_TRAFFIC_WITH_CONVERSION_SUCCESS = 'PAGE_TRAFFIC_WITH_CONVERSION_SUCCESS';
export const PAGE_TRAFFIC_WITH_CONVERSION_LOADING = 'PAGE_TRAFFIC_WITH_CONVERSION_LOADING';
export const PAGE_TRAFFIC_WITH_CONVERSION_FOR_GRAPH_SUCCESS = 'PAGE_TRAFFIC_WITH_CONVERSION_FOR_GRAPH_SUCCESS';
export const PAGE_TRAFFIC_WITH_CONVERSION_FOR_GRAPH_LOADING = 'PAGE_TRAFFIC_WITH_CONVERSION_FOR_GRAPH_LOADING';


export const getPageTrafficWithConversionData = ({ fromdate, todate, sku }) => async (dispatch) => {
        try {
            const { url } = getPageTrafficWithConversion
            const requestData = {
                ...getPageTrafficWithConversion,
                url: url.replace('{{fromDate}}', fromdate).replace('{{toDate}}', todate).replace('{{sku}}', sku)
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: PAGE_TRAFFIC_WITH_CONVERSION_SUCCESS,
                data,
            })
        } catch (e) {

            dispatch({
                type: PAGE_TRAFFIC_WITH_CONVERSION_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                }
            })
        }

}

export const getPageTrafficWithConversionDataForGraph = ({ fromdate, todate, sku }) => async (dispatch) => {
    try {
        const { url } = getPageTrafficWithConversionForGraph
        const requestData = {
            ...getPageTrafficWithConversionForGraph,
            url: url.replace('{{fromDate}}', fromdate).replace('{{toDate}}', todate).replace('{{sku}}', sku)
        };
        const data = await REQUEST(requestData);
        dispatch({
            type: PAGE_TRAFFIC_WITH_CONVERSION_FOR_GRAPH_SUCCESS,
            data,
        })
    } catch (e) {

        dispatch({
            type: PAGE_TRAFFIC_WITH_CONVERSION_FOR_GRAPH_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null
            }
        })
    }

}

export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: PAGE_TRAFFIC_WITH_CONVERSION_LOADING,
        isLoading
    })
}

export const handleGraphLoader = isGraphLoading => (dispatch) => {
    dispatch({
        type: PAGE_TRAFFIC_WITH_CONVERSION_FOR_GRAPH_LOADING,
        isGraphLoading
    })
}
